<div *ngIf="reportReportElement != null">
  <div *ngIf="showTitle">
    <div style="font-size: 20px; font-weight: bold; white-space: nowrap;">
      {{reportReportElement.Name}} 
    </div>
    <span style="font-size: 13px; font-style: italic; white-space: nowrap;">{{reportReportElement.Description != null ? reportReportElement.Description : ''}}</span>
  </div>

  <table style="width: 100%;">
    <tbody>
      <tr>
        <td style="width: 50%;">
          <div style="font-size: 24px; padding-bottom: 7px;">{{barChartTitle}}</div>
          <!--
                    bar-chart                 palette="bright"
            -->
          <dx-chart [rotated]="true" [customizeLabel]="barChartCustomizeLabel"
                    [dataSource]="data">
            <dxi-value-axis *ngIf="reportReportElement != null" tickInterval="0.5" [maxValueMargin]="maxValueMargin" [wholeRange]="{ startValue: reportReportElement != null ? reportReportElement.MinimumValueInDays : null }">
              <dxi-strip [startValue]="reportReportElement.MaximumThresholdInDays" color="rgba(255,155,85,0.15)">
                <dxo-label text="">
                  <dxo-font [color]="highThresholdColor"></dxo-font>
                </dxo-label>
              </dxi-strip>
              <dxi-strip [endValue]="reportReportElement.MinimumThresholdInDays" color="rgba(97,153,230,0.10)">
                <dxo-label text="">
                  <dxo-font [color]="lowThresholdColor"></dxo-font>
                </dxo-label>
              </dxi-strip>
              <dxo-strip-style>
                <dxo-label>
                  <dxo-font [weight]="500" [size]="14"></dxo-font>
                </dxo-label>
              </dxo-strip-style>
            </dxi-value-axis>
            <dxi-series argumentField="Name" 
                        valueField="LatestLagInDays_MinMaxLimited"
                        type="bar">
              <!--color="rgb(54, 163, 166)#ffaa66"-->
            </dxi-series>
            <dxo-legend [visible]="false"></dxo-legend>
          </dx-chart>
        </td>
        <td style="width: 50%;">
          <!--
                   pie-chart
          -->
          <dx-pie-chart palette="bright"
                        [dataSource]="data2">
            <dxi-series argumentField="Name"
                        valueField="LatestLagInDays">
              <dxo-label [visible]="true" position="columns" [customizeText]="customizePieChartLabel">
                <dxo-connector [visible]="true"
                               [width]="1">
                </dxo-connector>
              </dxo-label>
            </dxi-series>
          </dx-pie-chart>
        </td>
      </tr>
      <tr>
        <td style="padding-top: 20px; width: 50%;">
          <!--
          datagrid
    -->
          <div style="font-size: 24px; padding-bottom: 7px;">{{lineChartTitle}}</div>
          <dx-data-grid #grid
                        [dataSource]="data2"
                        [hoverStateEnabled]="true"
                        [rowAlternationEnabled]="true"
                        [showBorders]="true">
            <dxo-selection mode="none"></dxo-selection>
            <dxi-column dataField="Name" [caption]="ls.LNG('Label.Workstation')" [width]="200"></dxi-column>
            <dxi-column dataField="MaximumLag.LagInDays" cellTemplate="valueTemplate" [caption]="ls.LNG('Label.Highest')" [width]="75"></dxi-column>
            <dxi-column dataField="MinimumLag.LagInDays" cellTemplate="valueTemplate" [caption]="ls.LNG('Label.Lowest')" [width]="75"></dxi-column>
            <dxi-column dataField="NewestLag.LagInDays" cellTemplate="valueTemplate" [caption]="ls.LNG('Label.Yesterday')" [width]="90"></dxi-column>
            <dxi-column dataField="" [caption]="ls.LNG('Label.Trend')" cellTemplate="chartTemplate" ></dxi-column>

            <div *dxTemplate="let t of 'valueTemplate'">
              {{t.value.toFixed(1)}}
            </div>

            <div *dxTemplate="let t of 'chartTemplate'">
              <app-ams-trend-line width="250" height="25" [data]="t.data.LagTrend" valueField="LagInSeconds"></app-ams-trend-line>
            </div>
          </dx-data-grid>
        </td>
        <td style="width: 50%;">
        </td>
      </tr>
    </tbody>
  </table>
</div>
